import { Tooltip, message } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"
import urljoin from "url-join"

// ----------------------------------------------------------------------------

function _EventLinks(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, event } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [autoCopyFail, setAutoCopyFail] = useState(false)

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleClick(href) {
        navigator.clipboard
            .writeText(urljoin(window.location.origin, href))
            .then(() => {
                message.success("Link copiato negli appunti")
            })
            .catch((err) => {
                // eslint-disable-next-line
                console.log(err)
                message.error(
                    "Non è stato possibile copiare automaticamente il link. Per favore copiare manualmente."
                )
                setAutoCopyFail(true)
            })
    }

    function renderLink(name, href) {
        if (autoCopyFail) {
            return (
                <div className="link nohover">
                    <div className="name small">{name}</div>
                    <div className="href">
                        {window.location.origin}
                        {href}
                    </div>
                </div>
            )
        }
        return (
            <Tooltip title="Clicca il link per copiarlo negli appunti">
                <button className="link" onClick={() => handleClick(href)}>
                    <div className="name">{name}</div>
                </button>
            </Tooltip>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            {renderLink("Pagina di dettaglio evento", `/events/${event.id}`)}
            {event.agentReservationCodes?.map(({ label, code }) => {
                return renderLink(
                    `Link agenti '${label}'`,
                    `/events/${event.id}?code=${code}`
                )
            })}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_EventLinks.propTypes = {
    className: PropTypes.string.isRequired,
    event: PropTypes.object,
}

_EventLinks.defaultProps = {}

// ----------------------------------------------------------------------------

const EventLinks = styled(_EventLinks)`
    & {
        .link {
            display: block;
            text-align: left;
            background: transparent;
            margin: 0;
            border: none;
            width: 100%;
            transition: all 300ms;
            cursor: pointer;
            padding-block: 6px;

            &.nohover:hover {
                background-color: transparent;
                cursor: default;
            }

            &:hover {
                background-color: #eaeaea;
            }

            .name {
                white-space: nowrap;
                font-size: 15px;
                font-weight: 600;

                &.small {
                    font-size: 14px;
                    font-weight: 400;
                }
            }

            .href {
                white-space: nowrap;
                font-size: 12px;
                font-weight: 400;
                color: #666;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default EventLinks
